import React, { Component } from 'react';
import { connect } from "react-redux";

import { setLang, refreshToken, setConfig } from './features/settings';
import { getData } from "./core/fetchService";
import './css/App.css';
import Dashboard from './view/pages/dashboard';


class App extends Component {
	constructor(props) {
		super(props);
		this.props.setLang(localStorage.getItem('i18nextLng') || 'en');
	}

	interval;

	componentDidMount() {
    getData(`/config`, this.props.dispatch, data => {
      this.props.setConfig(data.config);
      if (!data.config.oauthServer)
        this.interval = setInterval(() => this.props.refreshToken(), data.config.refreshTokenInterval * 1000);
		});
	}

	componentWillUnmount() {
    if (!this.props.config.oauthServer)
      clearInterval(this.interval);
	}

	render() {
		return (
			<div className="App">
        <Dashboard/>
			</div>
		);
	}
}

const mapStateToProps = state => ({
  config: state.settings.config,
});

const mapDispatchToProps = dispatch => {
	return {
    dispatch, 
		setLang:        obj =>  { dispatch(setLang(obj)); },
		refreshToken:   () =>   { dispatch(refreshToken()); },
		setConfig:      s =>    { dispatch(setConfig(s)); },
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
